import axios from 'axios';
import NProgress from 'nprogress'
import * as vue from '../main.js'
// import router from '../router'
import { Loading, Message } from 'element-ui'


let l

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么;

  let { notLoading } = config

  if (!notLoading) l = Loading.service()

  NProgress.start()
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  // 对响应数据做点什么;

  if (l) l.close()
  NProgress.done()

  return response;
}, function (error) {
  if (l) l.close()

  // 对响应错误做点什么
  // if (error && error.response) {
  //   switch (error.response.status) {
  //     case 404:
  //       router.push({name:'404'});
  //       // error.message = '请求出错(404)'
  //       break;

  //     case 500:

  //       router.push({ name:'500'});
  //       //  error.message = '服务器错误(500)';
  //       break;

  //     default: error.message = `连接出错(${error.response.status})!`;
  //   }
  // }

  return Promise.reject(error);
});

let baseUrl = window.API

export const GET = (url, params) => {
  return axios.get(`${baseUrl}${url}`, { params: params }).then((data) => { return data })
}

// export const POST = (url, params) => {
//   return axios.post(`${baseUrl}${url}`, params, {
//     headers: {
//       "content-type": "application/json"
//     }
//   })
//     .then((data) => {
//       return data
//     })
// }
const CancelToken = axios.CancelToken;

export let axiosCancel
export const POST = (url, params, o) => {
  let { showFlag, notLoading, errAlert, timeout } = o || { showFlag: true, notLoading: false, errAlert: false }

  showFlag = showFlag === false ? false : true
  notLoading = notLoading || false
  errAlert = errAlert || false
  timeout = timeout || axios.defaults.timeout

  return axios.post(
    `${baseUrl}${url}`,
    params,
    {
      cancelToken: new CancelToken(function executor(c) {
        axiosCancel = c;
      }),
      headers: {
        "content-type": "application/json"
      },
      notLoading,
      timeout,
    })
    .then((data) => {
      Message.closeAll()
      return data

    }).catch(err => {
      if (axios.isCancel(err)) {
        console.log('request canceled', err.message)
      }
    })
}

export const POSTFILE = (url, params) => {
  return axios.post(`${baseUrl}${url}`, params,
    {
      headers: { appToken: localStorage.getItem('appToken'), projectId: localStorage.getItem('projectId'), 'Content-Type': 'multipart/form-data' }
    })
    .then((data) => { return data })
}
